<template>
  <base-section
    id="map"
    space="0"
  >
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d625.9046085873821!2d71.41308682923658!3d51.13394584026924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDA4JzAyLjIiTiA3McKwMjQnNDkuMSJF!5e0!3m2!1sru!2skz!4v1588879925463!5m2!1sru!2skz"
      width="100%"
      height="500"
      frameborder="0"
      style="border:0; display: block;"
      allowfullscreen
      aria-hidden="false"
      tabindex="0"
    />
  </base-section>
</template>

<script>
  export default {
    name: 'SectionBlockMap',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
